// The fixed public pages: the ones whose search metadata is defined in code
// (`STATIC_PAGES` in `apps/web/src/lib/static-page-copy.ts`) and may be
// overridden by an editor (`page_seo` on the server). Both sides key on this list, so a page
// added here fails the web build until it has default copy, and the API
// refuses an override for a page that is not on it.
export const STATIC_PAGE_PATHS = [
    '/',
    '/circles',
    '/networks',
    '/resources',
    '/join',
    '/start-a-circle',
    '/join-a-circle',
    '/join-a-network',
    '/help',
    '/community-guidelines',
    '/privacy',
    '/terms',
];
export function isStaticPagePath(path) {
    return STATIC_PAGE_PATHS.includes(path);
}
//# sourceMappingURL=static-pages.js.map